import React from "react"
import styled from "@emotion/styled"

import sidebarHero from "../../../images/brand-2026.png"


const SignUpFoxBox = styled.div`
  background-image: url(${sidebarHero});
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: clamp(280px, 29vw, 520px);
  /* Altura fija de una pantalla y pegado al borde superior: si el sidebar
     se estira con el largo del formulario (sign-up), queda mucho mas
     alargado que la imagen y el cover la recorta por los lados, cortando
     el titulo. Con sticky acompana el scroll sin dejar espacio en blanco. */
  align-self: flex-start;
  position: sticky;
  top: 0;
  height: 100vh;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background-color: #ffffff;
  @media (max-width: 850px) {
    display: none;
  }
`

const SignUpFox = () => (
  <SignUpFoxBox>
  </SignUpFoxBox>
)

export default SignUpFox
